import { OBRoutes } from '@utils/apiRoutes';
import { FormConfigurationDTO } from '@utils/interfaces';
import { useApiUrl } from '@gemini/lux-ds-pms';
import { useOBQuery } from '@hooks/useOBQuery';
import { StaticValues } from '@utils/enums/StaticValues.enum';

interface FormConfigProps {
  practiceId: string;
  isBranded?: boolean;
}

const useGetFormConfiguration = ({
  practiceId,
  isBranded,
}: FormConfigProps) => {
  const url = useApiUrl(
    OBRoutes.FormConfig,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##practiceId', practiceId);

  return useOBQuery<FormConfigurationDTO>(url, {
    enabled: !!url && !!practiceId,

    select: data => {
      const basePatientDetails = data.patientDetails;
      const baseContactsDetails = data.contactsDetails;

      let patientDetails = basePatientDetails;
      //per ora non esiste lato BFF, quindi lo creiamo qui
      let contactsDetails = baseContactsDetails ?? {
        firstName: StaticValues.FIELD_STATUS_MANDATORY,
        lastName: StaticValues.FIELD_STATUS_MANDATORY,
        dateOfBirth: StaticValues.FIELD_STATUS_MANDATORY,
        email: StaticValues.FIELD_STATUS_MANDATORY,
        phone: {
          prefix: StaticValues.FIELD_STATUS_MANDATORY,
          number: StaticValues.FIELD_STATUS_MANDATORY,
          type: StaticValues.FIELD_STATUS_MANDATORY,
        },
      };

      if (!isBranded) {
        // NOT BRANDED -> interdipendenza email/phone + type mandatory
        patientDetails = {
          ...patientDetails,
          email: StaticValues.INTERDEP_PHONENUMBER_EMAIL,
          phone: {
            ...patientDetails.phone,
            number: StaticValues.INTERDEP_PHONENUMBER_EMAIL,
            type: StaticValues.FIELD_STATUS_HIDDEN,
          },
        };

        contactsDetails = {
          ...contactsDetails,
          phone: {
            ...contactsDetails.phone,
            type: StaticValues.FIELD_STATUS_HIDDEN,
          },
        };
      } else {
        // BRANDED -> nascondo SOLO il type del phone number
        patientDetails = {
          ...patientDetails,
          phone: {
            ...patientDetails.phone,
            type: StaticValues.FIELD_STATUS_HIDDEN,
          },
        };

        contactsDetails = {
          ...contactsDetails,
          phone: {
            ...contactsDetails.phone,
            type: StaticValues.FIELD_STATUS_HIDDEN,
          },
        };
      }

      const askForInsuranceInformation = !!data.askForInsuranceInformation;

      return {
        ...data,
        patientDetails,
        contactsDetails,
        askForInsuranceInformation,
        insuranceDetailsOptional: !!data.insuranceDetailsOptional,
        insuranceMustDriveAvailability: !!data.insuranceMustDriveAvailability,
      };
    },
  });
};

export default useGetFormConfiguration;
